import { BrowserType, DesktopOsType, OsType } from '../../constants'
import isEmpty from '../../utility/isEmpty'

export default {
  isAndroid (state) {
    return state.isMobileBrowser === true && state.mobileOs === OsType.Android
  },

  isApple (state) {
    return state.mobileOs === OsType.Apple
  },

  isIOS (state) {
    return state.isMobileBrowser === true && state.mobileOs === OsType.Apple
  },

  isMac (state) {
    return state.desktopOs === DesktopOsType.Mac
  },

  isWindows (state) {
    return state.desktopOs === DesktopOsType.Windows
  },

  isMobileSafari (state) {
    return state.isMobileBrowser === true && state.browserType === BrowserType.Safari
  },

  hasQuickMessage (state) {
    return isEmpty(state.quickMessageText)
  },

  isPhoneOrTablet (state) {
    return state.isTabletBrowser || state.isMobileBrowser
  }
}
